import React from 'react';

const DeleteUserOverlay = ({ isActive, user, onPressConfirm, onPressCancel }) => {
  return (
    <div className={`modal ${isActive && 'is-active is-clipped'}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Esta seguro de querer borrar el usuario {user?.username}?</p>
          <button className="delete" aria-label="close" onClick={onPressCancel}></button>
        </header>
        <section className="modal-card-body has-background-danger">
          <p>El usuario sera borrado y no podra ser recuperado</p>
        </section>
        <footer className="modal-card-foot" style={{justifyContent: 'center'}}>
            <button className="button is-danger" onClick={onPressConfirm}>Borrar</button>
            <button className="button is-primary" onClick={onPressCancel}>Cancelar</button>
        </footer>
      </div>
    </div>
  )
}

export default DeleteUserOverlay;